module.exports = __webpack_public_path__ + "img/cow.cac70db3.svg";